import { render } from "./AccountDropdown.vue?vue&type=template&id=4c61174c"
import script from "./AccountDropdown.vue?vue&type=script&lang=js"
export * from "./AccountDropdown.vue?vue&type=script&lang=js"

import "./AccountDropdown.vue?vue&type=style&index=0&id=4c61174c&lang=css"

import exportComponent from "/home/runner/work/provider-frontend/provider-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__